/* ============================================================
   PRISMAX — native predictive search (header overlay)
   Shopify /search/suggest.json only. No app, no library.
   Degrades to a normal /search page when JS is off.
   All copy is read from data-* attributes set by the section.
   ============================================================ */
(function () {
  'use strict';

  var DEBOUNCE = 200;
  var MIN_CHARS = 2;
  var LIMIT = 6;
  var CACHE_MAX = 24;

  var timer = null;
  var ctrl = null;
  var seq = 0;
  var gid = 0;
  var options = [];
  var activeIndex = -1;
  var lastTerm = null;
  var cache = Object.create(null);
  var cacheKeys = [];

  /* ---------- element lookups (re-queried so theme-editor reloads are safe) ---------- */
  function panelEl() { return document.querySelector('[data-pxs-panel]'); }
  function headerEl() { var p = panelEl(); return p ? p.closest('.nav') : null; }
  function q(sel) { var p = panelEl(); return p ? p.querySelector(sel) : null; }
  function inputEl() { return q('[data-pxs-input]'); }
  function resultsEl() { return q('[data-pxs-results]'); }
  function mainEl() { return q('[data-pxs-main]'); }
  function sideEl() { return q('[data-pxs-side]'); }
  function statusEl() { return q('[data-pxs-status]'); }
  function triggerEl() { return document.querySelector('[data-pxs-open]'); }

  function data(name, fallback) {
    var p = panelEl();
    var v = p ? p.getAttribute('data-' + name) : null;
    return v === null || v === '' ? (fallback || '') : v;
  }

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function money(value) {
    if (typeof window.prismaxMoney === 'function') {
      try { return window.prismaxMoney(value); } catch (e) {}
    }
    var raw = String(value == null ? '' : value);
    var n = parseFloat(raw.replace(/[^0-9.]/g, '')) || 0;
    if (raw.indexOf('.') === -1) n = n / 100;
    try { return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: 2 }); }
    catch (e) { return '₹' + n; }
  }

  function thumbUrl(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- open / close ---------- */
  function isOpen() {
    var h = headerEl();
    return !!(h && h.classList.contains('pxs-open'));
  }

  function open() {
    var h = headerEl();
    var p = panelEl();
    if (!h || !p || isOpen()) return;
    h.classList.add('pxs-open');
    var t = triggerEl();
    if (t) t.setAttribute('aria-expanded', 'true');
    var i = inputEl();
    if (i) {
      i.setAttribute('aria-expanded', 'false');
      try { i.focus({ preventScroll: true }); } catch (e) { i.focus(); }
      i.select();
      if (i.value.trim().length >= MIN_CHARS) schedule(i.value);
    }
  }

  function close(refocus) {
    var h = headerEl();
    if (!h || !isOpen()) return;
    h.classList.remove('pxs-open');
    seq++; // invalidate anything still in flight so nothing renders into a closed panel
    stopLoading();
    abort();
    if (timer) { clearTimeout(timer); timer = null; }
    var t = triggerEl();
    if (t) {
      t.setAttribute('aria-expanded', 'false');
      if (refocus) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
    }
    var i = inputEl();
    if (i) i.setAttribute('aria-expanded', 'false');
  }

  function toggle() { isOpen() ? close(true) : open(); }

  /* ---------- loading state (always cleared, never sticks) ---------- */
  function startLoading() { var p = panelEl(); if (p) p.classList.add('is-loading'); }
  function stopLoading() { var p = panelEl(); if (p) p.classList.remove('is-loading'); }

  function abort() {
    if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
  }

  /* ---------- rendering ---------- */
  function clearResults() {
    var m = mainEl(); var s = sideEl(); var r = resultsEl();
    if (m) m.textContent = '';
    if (s) s.textContent = '';
    if (r) r.classList.remove('is-split');
    options = [];
    activeIndex = -1;
    setActiveDescendant(null);
    var i = inputEl();
    if (i) i.setAttribute('aria-expanded', 'false');
    var st = statusEl();
    if (st) st.textContent = '';
  }

  function optionRow(url, extraClass) {
    var a = el('a', 'pxs-row' + (extraClass ? ' ' + extraClass : ''));
    a.href = url || '#';
    a.setAttribute('role', 'option');
    a.setAttribute('aria-selected', 'false');
    a.id = 'pxs-opt-' + options.length;
    a.tabIndex = -1;
    options.push(a);
    return a;
  }

  function group(label, items, build) {
    if (!items || !items.length) return null;
    var g = el('div', 'pxs-group');
    g.setAttribute('role', 'group');
    var h = el('div', 'pxs-glabel mono');
    h.id = 'pxs-glabel-' + (++gid);
    h.textContent = label;
    g.setAttribute('aria-labelledby', h.id);
    g.appendChild(h);
    for (var i = 0; i < items.length; i++) {
      var row = build(items[i]);
      if (row) g.appendChild(row);
    }
    return g;
  }

  function productRow(p) {
    var a = optionRow(p.url, 'pxs-row-product');
    if (p.image) {
      var img = el('img', 'pxs-thumb');
      img.src = thumbUrl(p.image, 120);
      img.srcset = thumbUrl(p.image, 120) + ' 1x, ' + thumbUrl(p.image, 240) + ' 2x';
      img.alt = '';
      img.width = 46;
      img.height = 46;
      img.loading = 'lazy';
      img.decoding = 'async';
      a.appendChild(img);
    } else {
      a.appendChild(el('span', 'pxs-thumb pxs-thumb-empty'));
    }
    var box = el('span', 'pxs-body');
    var t = el('span', 'pxs-t');
    t.textContent = p.title || '';
    box.appendChild(t);
    var meta = el('span', 'pxs-p');
    if (p.available === false) {
      meta.textContent = data('soldout-label', 'Sold out');
      meta.className = 'pxs-p pxs-p-out';
    } else {
      meta.textContent = money(p.price != null ? p.price : p.price_min);
    }
    box.appendChild(meta);
    a.appendChild(box);
    return a;
  }

  function textRow(item) {
    var a = optionRow(item.url, 'pxs-row-text');
    var t = el('span', 'pxs-t');
    t.textContent = item.title || '';
    a.appendChild(t);
    var go = el('span', 'pxs-go');
    go.textContent = '→';
    go.setAttribute('aria-hidden', 'true');
    a.appendChild(go);
    return a;
  }

  function emptyState() {
    var box = el('div', 'pxs-empty');
    var p = el('p', 'pxs-empty-text muted');
    p.textContent = data('empty-text', 'No matches yet.');
    box.appendChild(p);
    var url = data('viewall-url', '/collections/all');
    var a = el('a', 'btn-link pxs-viewall');
    a.href = url;
    a.textContent = data('viewall-label', 'Browse all products');
    var go = el('span');
    go.textContent = '→';
    go.setAttribute('aria-hidden', 'true');
    a.appendChild(go);
    box.appendChild(a);
    return box;
  }

  function render(term, res) {
    var m = mainEl(), s = sideEl(), r = resultsEl();
    if (!m || !s || !r) return;
    clearResults();

    var products = (res && res.products) || [];
    var collections = (res && res.collections) || [];
    var pages = (res && res.pages) || [];

    var gp = group(data('label-products', 'Products'), products, productRow);
    var gc = group(data('label-collections', 'Collections'), collections, textRow);
    var gg = group(data('label-pages', 'Pages'), pages, textRow);

    if (gp) m.appendChild(gp);
    if (gc) s.appendChild(gc);
    if (gg) s.appendChild(gg);

    var total = options.length;
    if (!total) {
      m.appendChild(emptyState());
    } else if (gc || gg) {
      r.classList.add('is-split');
    }

    var i = inputEl();
    if (i) i.setAttribute('aria-expanded', total ? 'true' : 'false');

    var st = statusEl();
    if (st) {
      st.textContent = total
        ? data('results-note', '[count] results').replace('[count]', String(total))
        : data('empty-text', 'No matches yet.');
    }
  }

  /* ---------- keyboard highlight ---------- */
  function setActiveDescendant(id) {
    var i = inputEl();
    if (!i) return;
    if (id) i.setAttribute('aria-activedescendant', id);
    else i.removeAttribute('aria-activedescendant');
  }

  function setActive(index) {
    if (!options.length) { activeIndex = -1; setActiveDescendant(null); return; }
    if (index < 0) index = options.length - 1;
    if (index > options.length - 1) index = 0;
    for (var n = 0; n < options.length; n++) {
      var on = n === index;
      options[n].classList.toggle('is-active', on);
      options[n].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    activeIndex = index;
    setActiveDescendant(options[index].id);
    if (options[index].scrollIntoView) {
      options[index].scrollIntoView({ block: 'nearest' });
    }
  }

  /* ---------- fetching ---------- */
  function suggestUrl(term) {
    var base = data('suggest-url', '/search/suggest').replace(/\.json$/, '');
    return base + '.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,page' +
      '&resources[limit]=' + LIMIT +
      '&resources[options][unavailable_products]=last';
  }

  function remember(key, value) {
    if (!(key in cache)) {
      cacheKeys.push(key);
      if (cacheKeys.length > CACHE_MAX) { delete cache[cacheKeys.shift()]; }
    }
    cache[key] = value;
  }

  function run(term) {
    var trimmed = term.trim();
    if (trimmed.length < MIN_CHARS) {
      abort();
      stopLoading();
      clearResults();
      lastTerm = null;
      return;
    }
    if (trimmed === lastTerm) return;
    lastTerm = trimmed;

    if (cache[trimmed]) { stopLoading(); render(trimmed, cache[trimmed]); return; }

    abort();
    var ticket = ++seq;
    var signal;
    if (typeof AbortController === 'function') {
      ctrl = new AbortController();
      signal = ctrl.signal;
    }
    startLoading();

    fetch(suggestUrl(trimmed), { signal: signal, headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('bad status ' + r.status);
        return r.json();
      })
      .then(function (json) {
        if (ticket !== seq) return;
        var res = (json && json.resources && json.resources.results) || {};
        remember(trimmed, res);
        render(trimmed, res);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (ticket !== seq) return;
        render(trimmed, {});
      })
      .then(function () {
        if (ticket === seq) stopLoading();
      });
  }

  function schedule(term) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; run(term); }, DEBOUNCE);
  }

  /* ---------- events (delegated: survives theme-editor section reloads) ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var trigger = e.target.closest('[data-pxs-open]');
    if (trigger) {
      if (!panelEl()) return; // no panel -> let the fallback link work
      e.preventDefault();
      toggle();
      return;
    }

    if (e.target.closest('[data-pxs-close]')) {
      e.preventDefault();
      close(true);
      return;
    }

    if (!isOpen()) return;
    if (e.target.closest('[data-pxs-panel]')) return;
    close(false);
  });

  document.addEventListener('input', function (e) {
    var i = e.target;
    if (!i || !i.hasAttribute || !i.hasAttribute('data-pxs-input')) return;
    // typing always deselects, so Enter submits the typed query until the user arrows down again
    if (activeIndex > -1) {
      for (var n = 0; n < options.length; n++) {
        options[n].classList.remove('is-active');
        options[n].setAttribute('aria-selected', 'false');
      }
      activeIndex = -1;
      setActiveDescendant(null);
    }
    schedule(i.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      close(true);
      return;
    }
    var i = e.target;
    if (!i || !i.hasAttribute || !i.hasAttribute('data-pxs-input')) return;

    if (e.key === 'ArrowDown') {
      if (!options.length) return;
      e.preventDefault();
      setActive(activeIndex + 1);
    } else if (e.key === 'ArrowUp') {
      if (!options.length) return;
      e.preventDefault();
      setActive(activeIndex - 1);
    } else if (e.key === 'Home' && options.length && activeIndex > -1) {
      e.preventDefault();
      setActive(0);
    } else if (e.key === 'End' && options.length && activeIndex > -1) {
      e.preventDefault();
      setActive(options.length - 1);
    } else if (e.key === 'Enter') {
      if (activeIndex > -1 && options[activeIndex]) {
        e.preventDefault();
        window.location.href = options[activeIndex].href;
      }
      // otherwise the form submits natively to routes.search_url?q=
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-pxs-form')) return;
    var i = form.querySelector('[data-pxs-input]');
    if (!i || !i.value.trim()) e.preventDefault();
  });

  document.addEventListener('shopify:section:load', function () {
    if (timer) { clearTimeout(timer); timer = null; }
    abort();
    options = [];
    activeIndex = -1;
    lastTerm = null;
  });
})();
